
import { css } from 'lit';
export default css`
:host([trim]) .form-block{
    padding:0px;
  }

.form-block{
  padding:var(--spacing-12) var(--spacing-0);
  display:block;
  margin:var(--spacing-0);
}
`;